import { MenuItem } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { ImportBillReceiversFormValues, UpdateKeyListBillReceivers } from "../importBillReceiversTypes"

export function SelectUpdateKeyDropdown() {
    return (
        <LocalizedStrict id="data-import-csv-field-update-key" attrs={{ label: true }}>
            <FormikDropdown<ImportBillReceiversFormValues> name="updateKey" label="Update key">
                {Object.values(UpdateKeyListBillReceivers).map((item) => {
                    return (
                        <MenuItem key={item} value={item}>
                            <LocalizedEnum base="create-or-edit-company-id-cards-update-key-mode" enumValue={item}>
                                <> {item}</>
                            </LocalizedEnum>
                        </MenuItem>
                    )
                })}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
